import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiService, ApiVersion } from 'src/app/services/api.service';
import { AutenticarModel } from './autenticar.model';

@Injectable()
export class AutenticarService {
    constructor(
        private http: HttpClient,
        private router: Router,
        private apiService: ApiService
    ) {}

    isLoggedIn(): boolean {
        return !!sessionStorage.getItem('@poaquestionario:token');
    }

    getToken(): string {
        return sessionStorage.getItem('@poaquestionario:token');
    }

    login(token: string): Observable<AutenticarModel> {
        return this.http
            .get<AutenticarModel>(
                `${this.apiService.getUrl()}/${ApiVersion}/auth/${token}/token-externo`
            )
            .pipe(
                tap((auth) => {
                    sessionStorage.setItem('@poaquestionario:token', auth.token);
                })
            );
    }

    handleUnauthorized() {
        window.location.href = this.apiService.getRedirectUrl();
        console.warn(this.apiService.getRedirectUrl());
    }

    // handleLogin(): void {
    //     this.router.navigate
    // }
}
